import React, { useState } from "react";
import { db, doc, setDoc } from "../config/firebase";
import "./PhoneNumberModal.css";

const PhoneNumberModal = ({ user, onSuccess, onClose }) => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Normalize and validate Indian 10-digit mobile number
    const cleanPhone = phone.replace(/[\s\-()]/g, "").replace(/^(\+?91)/, "");
    if (!/^[6-9]\d{9}$/.test(cleanPhone)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    setLoading(true);
    try {
      await setDoc(
        doc(db, "users", user.uid),
        { phone: cleanPhone, updatedAt: new Date().toISOString() },
        { merge: true }
      );
      onSuccess(cleanPhone);
    } catch (err) {
      console.error("Error saving phone number:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="phone-modal-overlay" onClick={onClose}>
      <div className="phone-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="phone-modal-close" onClick={onClose} aria-label="Close">×</button>

        <div className="phone-modal-header">
          <h2>One Last Step</h2>
          <p>We need your phone number to confirm your order and pickup details.</p>
        </div>

        {error && <div className="phone-modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="phone-modal-form">
          <div className="form-group">
            <label htmlFor="checkout-phone">Phone Number *</label>
            <input
              id="checkout-phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              placeholder="+91 98765 43210"
              autoComplete="tel"
              autoFocus
            />
          </div>

          <button type="submit" className="phone-modal-btn" disabled={loading}>
            {loading ? "Saving..." : "Continue to Payment"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PhoneNumberModal;